import { cx } from "@/utils";
import { flexRender } from "@tanstack/react-table";

const TableRow = ({ row }) => {
  const cells = row.getVisibleCells();
  return (
    <tr className={"even:bg-cp-grey-100"}>
      {cells.map((cell) => {
        return (
          <td
            key={cell.id}
            className={cx("p-3 text-left text-sm text-gray-900")}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        );
      })}
    </tr>
  );
};

export default TableRow;
